export default __webpack_public_path__ + "static/media/Pistol_3.c1d5ec5a.png";